<template>
  <div class="side-menu" :class="{activee: sideBarOpened}">
    <button @click="setSideBarOpened(false)" class="menu-close">
      <img src="/assets/img/cross@3x.png" alt />
    </button>
    <div class="side-menu-inner">
      <div class="menu-main">
        <ul>
          <li @click="setSideBarOpened(false)">
            <router-link to="/indicator">Indicator</router-link>
          </li>
          <li  v-if="refillLink">
            <a @click="setSideBarOpened(false)" target="_blank" :href="refillLink">Buy {{filterType === 'v1' ? 'Replacement' : 'Refill'}} Pack</a>
          </li>
          <li @click="setSideBarOpened(false)">
            <a v-if="filterType === 'v1'" href="https://www.phoxwater.com/pages/faqs">FAQ's</a>
            <router-link v-else to="/faq">FAQ's</router-link>
          </li>
          <li @click="setSideBarOpened(false)">
            <router-link to="/contact">Contact Us</router-link>
          </li>
          <li v-if="user"  @click="setSideBarOpened(false)">
            <a @click.prevent="logout" href="#">Logout</a>
          </li>
        </ul>
      </div>
      <div class="social-links">
        <a href="https://www.instagram.com/phoxwater/" @click="setSideBarOpened(false)" target="_blank">
          <img src="/assets/img/instagram.svg" alt />
        </a>
        <a href="https://twitter.com/PhoxWater" @click="setSideBarOpened(false)" target="_blank">
          <img src="/assets/img/twitter.svg" alt />
        </a>
        <a href="https://fb.com/phoxwater/" @click="setSideBarOpened(false)" target="_blank">
          <img src="/assets/img/facebook.svg" alt />
        </a>
      </div>
      <div @click="setSideBarOpened(false)" class="bottom-logo">
        <router-link to="/">
          <img src="/assets/img/logo-2.svg" alt />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { auth } from 'firebase'
export default {
  computed: {
    ...mapState('app', ['sideBarOpened']),
    ...mapState('authentication', ['user']),
    filterType () {
      return this.user && this.user.filter && this.user.filter.type
    },
    refillLink () {
      // return this.filterType && (this.filterType === 'v1' ? 'https://u1sx8pulyylda4u0-17348003.shopifypreview.com/products_preview?preview_key=f8484c263434e7d5924942fb6dc4f4a7' : 'https://u1sx8pulyylda4u0-17348003.shopifypreview.com/products_preview?preview_key=f8484c263434e7d5924942fb6dc4f4a7') 
      return 'https://www.phoxwater.com/'
    }
  },
  methods: {
    ...mapMutations('app', ['setSideBarOpened']),
    async logout() {
      await auth().signOut()
    }
  }
}
</script>

<style>
</style>